import React, { useEffect, useState } from "react";

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#000000",
    transition: "opacity 0.8s ease, visibility 0.8s ease",
  },
  hidden: {
    opacity: 0,
    visibility: "hidden",
    pointerEvents: "none",
  },
  spinnerContainer: {
    position: "relative",
    width: 164,
    height: 164,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 36,
  },
  outerRing: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    border: "2px solid rgba(255, 255, 255, 0.08)",
    animation: "spin-outer 3s linear infinite",
  },
  innerRing: {
    position: "absolute",
    inset: 16,
    borderRadius: "50%",
    border: "2px solid transparent",
    borderBottom: "2px solid #58EFFE",
    borderRight: "2px solid rgba(88, 239, 254, 0.3)",
    animation: "spin-inner 2s linear infinite reverse",
  },
  pulseRing: {
    position: "absolute",
    inset: -8,
    borderRadius: "50%",
    border: "1px solid rgba(88, 239, 254, 0.15)",
    animation: "pulse-ring 2.5s ease-in-out infinite",
  },
  logoWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    animation: "fade-in-logo 1.2s ease 0.5s both",
  },
  dot: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: "linear-gradient(130deg, #58EFFE, #39F3CC)",
    boxShadow: "0 0 30px rgba(88, 239, 254, 0.6), 0 0 60px rgba(57, 243, 204, 0.3)",
  },
  name: {
    color: "#ffffff",
    fontSize: "1.1rem",
    fontWeight: 800,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginTop: 4,
  },
  statusContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    animation: "fade-in-logo 1s ease 0.8s both",
  },
  statusText: {
    color: "#58EFFE",
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.2em",
    textTransform: "uppercase",
  },
  barWrap: {
    width: 200,
    height: 2,
    borderRadius: 4,
    background: "rgba(255, 255, 255, 0.06)",
    overflow: "hidden",
  },
  bar: {
    height: "100%",
    borderRadius: 4,
    background: "linear-gradient(90deg, #58EFFE, #39F3CC)",
    boxShadow: "0 0 10px rgba(88, 239, 254, 0.5)",
    transition: "width 0.3s ease",
  },
  hint: {
    marginTop: 8,
    color: "rgba(255, 255, 255, 0.2)",
    fontSize: "0.68rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
};

const keyframes = `
@keyframes spin-outer {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes spin-inner {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes pulse-ring {
  0%, 100% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.08); opacity: 0.08; }
}
@keyframes fade-in-logo {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}`;

export default function LoadingScreen({ ready }) {
  const [progress, setProgress] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setProgress((p) => {
        if (p >= 90 && !ready) return p;
        if (p >= 100) { clearInterval(id); return 100; }
        return p + (ready ? 12 : 4);
      });
    }, 120);
    return () => clearInterval(id);
  }, [ready]);

  useEffect(() => {
    if (progress >= 100) {
      const t = setTimeout(() => setDismissed(true), 500);
      return () => clearTimeout(t);
    }
  }, [progress]);

  if (dismissed) return null;

  return (
    <>
      <style>{keyframes}</style>
      <div style={{ ...styles.overlay, ...(progress >= 100 ? styles.hidden : {}) }}>
        <div style={styles.spinnerContainer}>
          <div style={styles.pulseRing} />
          <div style={styles.outerRing} />
          <div style={styles.innerRing} />
          <div style={styles.logoWrap}>
            <span style={styles.dot} />
            <span style={styles.name}>Klorum</span>
          </div>
        </div>

        <div style={styles.statusContainer}>
          <span style={styles.statusText}>inicializando</span>
          <div style={styles.barWrap}>
            <div style={{ ...styles.bar, width: `${Math.min(progress, 100)}%` }} />
          </div>
          <span style={styles.hint}>Cargando experiencia</span>
        </div>
      </div>
    </>
  );
}
